import { render, staticRenderFns } from "./GeneralInformation.vue?vue&type=template&id=35b8dc6d&scoped=true"
import script from "./GeneralInformation.vue?vue&type=script&lang=ts"
export * from "./GeneralInformation.vue?vue&type=script&lang=ts"
import style0 from "./GeneralInformation.vue?vue&type=style&index=0&id=35b8dc6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b8dc6d",
  null
  
)

export default component.exports